// Standard-Initialisierungswerte
export const INITIAL_FORDERUNG = {
  id: 1,
  aktenzeichen: '',
  nameSchuldner: '',
  vornameSchuldner: '',
  betrag: '',
  waehrung: 'EUR',
  vorgangsNr: ''
};

export const INITIAL_PFANDOBJEKT = {
  id: 1,
  identifikationstyp: 'VerweisAufGrundbuchblatt', // oder 'BezeichnungImBestandsverzeichnis'
  identifikation: {
    // Felder für VerweisAufGrundbuchblatt
    ortGrundbuch: '',
    amtsgericht: '',
    band: '',
    blattNr: '',
    strasse: '',
    hausNr: '',
    plz: '',
    ort: '',
    // Felder für BezeichnungImBestandsverzeichnis
    lfdNrImBestandsverzeichnis: '',
    gemarkung: '',
    flur: '',
    flurstueck: ''
  },
  // Felder auf oberster Ebene des Pfandobjekts
  abteilungGrundbuch: '',
  lfdNrAbteilungGrundbuch: ''
};

export const INITIAL_GRUNDPFANDRECHT = {
  id: 1,
  aktenzeichen: '',
  betrag: '',
  umfang: '',
  rechtlicherGrund: '',
  datumRechtlicherGrund: '',
  pfandobjekte: [INITIAL_PFANDOBJEKT]
};

export const INITIAL_UEBERTRAGUNGSBERECHTIGTER = {
  id: 1,
  name: '',
  strasse: '',
  hausnummer: '',
  postleitzahl: '',
  ort: ''
};

// Aktivitäts-Checks
export const isPfAktiv = (forderung) => {
  return (
    (forderung.aktenzeichen || '').trim() !== '' ||
    (forderung.nameSchuldner || '').trim() !== '' ||
    (forderung.vornameSchuldner || '').trim() !== '' ||
    (forderung.betrag || '').toString().trim() !== '' ||
    (forderung.vorgangsNr || '').trim() !== ''
  );
};

export const isGpAktiv = (gp) => {
  const hasGpField = (gp.aktenzeichen || '').trim() !== '' ||
    (gp.betrag || '').toString().trim() !== '' ||
    (gp.umfang || '').toString().trim() !== '' ||
    (gp.rechtlicherGrund || '').trim() !== '' ||
    (gp.datumRechtlicherGrund || '').trim() !== '';

  const hasPoField = (gp.pfandobjekte || []).some(po => {
    // Gemeinsame Felder
    const hasCommonFields = (po.abteilungGrundbuch || '').trim() !== '' ||
      (po.lfdNrAbteilungGrundbuch || '').toString().trim() !== '';

    const ident = po.identifikation || {};

    // VerweisAufGrundbuchblatt Felder
    const hasGrundbuchFields = (ident.ortGrundbuch || '').trim() !== '' ||
      (ident.amtsgericht || '').trim() !== '' ||
      (ident.blattNr || '').trim() !== '' ||
      (ident.band || '').trim() !== '' ||
      (ident.strasse || '').trim() !== '' ||
      (ident.hausNr || '').trim() !== '' ||
      (ident.plz || '').trim() !== '' ||
      (ident.ort || '').trim() !== '';

    // BezeichnungImBestandsverzeichnis Felder
    const hasBestandsFields = (ident.lfdNrImBestandsverzeichnis || '').toString().trim() !== '' ||
      (ident.gemarkung || '').trim() !== '' ||
      (ident.flur || '').trim() !== '' ||
      (ident.flurstueck || '').trim() !== '';

    return hasCommonFields || hasGrundbuchFields || hasBestandsFields;
  });

  return hasGpField || hasPoField;
};

// Zentrale Validierungsfunktion
export const validateFormData = (formData, persoenlicheForderungen, grundpfandrechte, uebertragungsberechtigte) => {
  const newErrors = {};
  
  // Grunddaten
  if (!((formData.transaktion) || '').trim()) {
    newErrors.transaktion = 'Transaktion ist erforderlich';
  }

  // Grundpfandrechte Validierung
  grundpfandrechte.forEach((gp) => {
    if (!isGpAktiv(gp)) return;

    const aktenzeichen = (gp.aktenzeichen || '').trim();
    const betragText = (gp.betragText || gp.betrag || '').toString().trim();
    const umfangText = (gp.umfangText || gp.umfang || '').toString().trim();
    const rechtlicherGrund = (gp.rechtlicherGrund || '').trim();

    if (!aktenzeichen) {
      newErrors[`gp_${gp.id}_aktenzeichen`] = 'Aktenzeichen ist erforderlich';
    } else if (aktenzeichen.length < 2) {
      newErrors[`gp_${gp.id}_aktenzeichen`] = 'Aktenzeichen muss mindestens 2 Zeichen lang sein';
    } else if (aktenzeichen.length > 100) {
      newErrors[`gp_${gp.id}_aktenzeichen`] = 'Aktenzeichen darf maximal 100 Zeichen lang sein';
    }

    if (!betragText) {
      newErrors[`gp_${gp.id}_betrag`] = 'Betrag ist erforderlich';
    } else if (betragText.length < 2) {
      newErrors[`gp_${gp.id}_betrag`] = 'Betrag muss mindestens 2 Zeichen lang sein';
    } else if (betragText.length > 100) {
      newErrors[`gp_${gp.id}_betrag`] = 'Betrag darf maximal 100 Zeichen lang sein';
    }

    if (!umfangText) {
      newErrors[`gp_${gp.id}_umfang`] = 'Umfang ist erforderlich';
    } else if (umfangText.length < 2) {
      newErrors[`gp_${gp.id}_umfang`] = 'Umfang muss mindestens 2 Zeichen lang sein';
    } else if (umfangText.length > 100) {
      newErrors[`gp_${gp.id}_umfang`] = 'Umfang darf maximal 100 Zeichen lang sein';
    }

    if (!rechtlicherGrund) {
      newErrors[`gp_${gp.id}_rechtlicherGrund`] = 'Rechtlicher Grund ist erforderlich';
    } else if (rechtlicherGrund.length < 2) {
      newErrors[`gp_${gp.id}_rechtlicherGrund`] = 'Rechtlicher Grund muss mindestens 2 Zeichen lang sein';
    } else if (rechtlicherGrund.length > 100) {
      newErrors[`gp_${gp.id}_rechtlicherGrund`] = 'Rechtlicher Grund darf maximal 100 Zeichen lang sein';
    }

    if (!(gp.datumRechtlicherGrund || '').trim()) {
      newErrors[`gp_${gp.id}_datumRechtlicherGrund`] = 'Datum des rechtlichen Grundes ist erforderlich';
    }

    // Pfandobjekte validieren
    gp.pfandobjekte.forEach((po) => {
      // Gemeinsame Pflichtfelder
      const commonFields = [
        { name: 'abteilungGrundbuch', value: (po.abteilungGrundbuch || '').trim(), label: 'Abteilung', minLength: 1, maxLength: 10 },
        { name: 'lfdNrAbteilungGrundbuch', value: (po.lfdNrAbteilungGrundbuch || '').toString().trim(), label: 'Lfd. Nr.', isNumber: true }
      ];

      commonFields.forEach(f => {
        const errorKey = `po_${gp.id}_${po.id}_${f.name}`;
        if (!f.value) {
          newErrors[errorKey] = `${f.label} ist erforderlich`;
        } else if (f.minLength && f.value.length < f.minLength) {
          newErrors[errorKey] = `${f.label} muss mindestens ${f.minLength} Zeichen lang sein`;
        } else if (f.maxLength && f.value.length > f.maxLength) {
          newErrors[errorKey] = `${f.label} darf maximal ${f.maxLength} Zeichen lang sein`;
        }
      });

      // Validierung basierend auf identifikationstyp
      const identifikationstyp = po.identifikationstyp || 'VerweisAufGrundbuchblatt';
      const ident = po.identifikation || {};

      if (identifikationstyp === 'VerweisAufGrundbuchblatt') {
        const grundbuchFields = [
          { name: 'identifikation.ortGrundbuch', value: (ident.ortGrundbuch || '').trim(), label: 'Ort des Grundbuchs', minLength: 2, maxLength: 100 },
          { name: 'identifikation.amtsgericht', value: (ident.amtsgericht || '').trim(), label: 'Amtsgericht', minLength: 2, maxLength: 100 },
          { name: 'identifikation.blattNr', value: (ident.blattNr || '').trim(), label: 'Blatt', minLength: 1, maxLength: 10 },
          { name: 'identifikation.strasse', value: (ident.strasse || '').trim(), label: 'Straße', minLength: 2, maxLength: 100 },
          { name: 'identifikation.hausNr', value: (ident.hausNr || '').trim(), label: 'Hausnummer', minLength: 1, maxLength: 10 },
          { name: 'identifikation.plz', value: (ident.plz || '').trim(), label: 'PLZ', pattern: /^[0-9]{4,5}$/ },
          { name: 'identifikation.ort', value: (ident.ort || '').trim(), label: 'Ort', minLength: 2, maxLength: 100 }
        ];

        grundbuchFields.forEach(f => {
          const errorKey = `po_${gp.id}_${po.id}_${f.name}`;
          if (!f.value) {
            newErrors[errorKey] = `${f.label} ist erforderlich`;
          } else if (f.pattern && !f.pattern.test(f.value)) {
            if (f.name === 'identifikation.plz') {
              newErrors[errorKey] = 'Postleitzahl muss 4 oder 5 Ziffern enthalten';
            } else if (f.name === 'identifikation.hausNr') {
              newErrors[errorKey] = 'Ungültige Hausnummer (Erlaubte Formate: Zahl (1-9999), Zahl+Buchstabe (12a), Zahl/Teilnummer (12/1), Zahl-Teilnummer (12-1))';
            }
          } else if (f.minLength && f.value.length < f.minLength) {
            newErrors[errorKey] = `${f.label} muss mindestens ${f.minLength} Zeichen lang sein`;
          } else if (f.maxLength && f.value.length > f.maxLength) {
            newErrors[errorKey] = `${f.label} darf maximal ${f.maxLength} Zeichen lang sein`;
          }
        });

        // Band ist optional, aber wenn gesetzt, muss es validiert werden
        const band = (ident.band || '').trim();
        if (band && band.length < 1) {
          newErrors[`po_${gp.id}_${po.id}_identifikation.band`] = 'Band muss mindestens 1 Zeichen lang sein';
        } else if (band && band.length > 10) {
          newErrors[`po_${gp.id}_${po.id}_identifikation.band`] = 'Band darf maximal 10 Zeichen lang sein';
        }
      } else if (identifikationstyp === 'BezeichnungImBestandsverzeichnis') {
        const bestandsFields = [
          { name: 'identifikation.lfdNrImBestandsverzeichnis', value: (ident.lfdNrImBestandsverzeichnis || '').toString().trim(), label: 'Lfd. Nr. im Bestandsverzeichnis', isNumber: true },
          { name: 'identifikation.gemarkung', value: (ident.gemarkung || '').trim(), label: 'Gemarkung', minLength: 2, maxLength: 100 },
          { name: 'identifikation.flur', value: (ident.flur || '').trim(), label: 'Flur', minLength: 1, maxLength: 100 },
          { name: 'identifikation.flurstueck', value: (ident.flurstueck || '').trim(), label: 'Flurstück', minLength: 1, maxLength: 100 }
        ];

        bestandsFields.forEach(f => {
          const errorKey = `po_${gp.id}_${po.id}_${f.name}`;
          if (!f.value) {
            newErrors[errorKey] = `${f.label} ist erforderlich`;
          } else if (!f.isNumber && f.minLength && f.value.length < f.minLength) {
            newErrors[errorKey] = `${f.label} muss mindestens ${f.minLength} Zeichen lang sein`;
          } else if (!f.isNumber && f.maxLength && f.value.length > f.maxLength) {
            newErrors[errorKey] = `${f.label} darf maximal ${f.maxLength} Zeichen lang sein`;
          }
        });
      }
    });
  });

  // Übertragungsberechtigter
  const ub = uebertragungsberechtigte[0];
  if (ub) {
    const ubName = (ub.name || '').trim();
    const ubStrasse = (ub.strasse || '').trim();
    const ubHausnummer = (ub.hausnummer || '').trim();
    const ubPlz = (ub.postleitzahl || '').trim();
    const ubOrt = (ub.ort || '').trim();

    if (!ubName) newErrors.ubName = 'Name ist erforderlich';
    else if (ubName.length < 2) newErrors.ubName = 'Name muss mindestens 2 Zeichen lang sein';
    else if (ubName.length > 100) newErrors.ubName = 'Name darf maximal 100 Zeichen lang sein';

    if (!ubStrasse) newErrors.ubStrasse = 'Straße ist erforderlich';
    else if (ubStrasse.length < 2) newErrors.ubStrasse = 'Straße muss mindestens 2 Zeichen lang sein';
    else if (ubStrasse.length > 100) newErrors.ubStrasse = 'Straße darf maximal 100 Zeichen lang sein';

    if (!ubHausnummer) {
      newErrors.ubHausnummer = 'Hausnummer ist erforderlich';
    } else if (!/^[1-9][0-9]{0,3}([a-zA-Z]|[-/][1-9][0-9]{0,3})?$/.test(ubHausnummer)) {
      newErrors.ubHausnummer = 'Ungültige Hausnummer (Erlaubte Formate: Zahl (1-9999), Zahl+Buchstabe (12a), Zahl/Teilnummer (12/1), Zahl-Teilnummer (12-1))';
    }

    if (!ubPlz) {
      newErrors.ubPlz = 'Postleitzahl ist erforderlich';
    } else if (!/^[0-9]{4,5}$/.test(ubPlz)) {
      newErrors.ubPlz = 'Postleitzahl muss 4 oder 5 Ziffern enthalten';
    }

    if (!ubOrt) newErrors.ubOrt = 'Ort ist erforderlich';
    else if (ubOrt.length < 2) newErrors.ubOrt = 'Ort muss mindestens 2 Zeichen lang sein';
    else if (ubOrt.length > 100) newErrors.ubOrt = 'Ort darf maximal 100 Zeichen lang sein';
  }

  // Persönliche Forderungen
  persoenlicheForderungen.forEach((forderung) => {
    if (!isPfAktiv(forderung)) return;

    const aktenzeichen = (forderung.aktenzeichen || '').trim();
    const name = (forderung.nameSchuldner || '').trim();
    const vorname = (forderung.vornameSchuldner || '').trim();
    const waehrung = (forderung.waehrung || '').trim();
    const betragStr = (forderung.betrag || '').toString().trim();
    const vorgangsNr = (forderung.vorgangsNr || '').trim();

    if (!aktenzeichen) {
      newErrors[`pf_${forderung.id}_aktenzeichen`] = 'Aktenzeichen ist erforderlich';
    } else if (aktenzeichen.length < 2) {
      newErrors[`pf_${forderung.id}_aktenzeichen`] = 'Aktenzeichen muss mindestens 2 Zeichen lang sein';
    } else if (aktenzeichen.length > 100) {
      newErrors[`pf_${forderung.id}_aktenzeichen`] = 'Aktenzeichen darf maximal 100 Zeichen lang sein';
    }

    if (!name) {
      newErrors[`pf_${forderung.id}_nameSchuldner`] = 'Name des Schuldners ist erforderlich';
    } else if (name.length < 2) {
      newErrors[`pf_${forderung.id}_nameSchuldner`] = 'Name muss mindestens 2 Zeichen lang sein';
    } else if (name.length > 100) {
      newErrors[`pf_${forderung.id}_nameSchuldner`] = 'Name darf maximal 100 Zeichen lang sein';
    }

    if (vorname !== '') {
      if (vorname.length < 2) {
        newErrors[`pf_${forderung.id}_vornameSchuldner`] = 'Vorname muss mindestens 2 Zeichen lang sein';
      } else if (vorname.length > 100) {
        newErrors[`pf_${forderung.id}_vornameSchuldner`] = 'Vorname darf maximal 100 Zeichen lang sein';
      }
    }

    if (!waehrung) {
      newErrors[`pf_${forderung.id}_waehrung`] = 'Währung ist erforderlich';
    } else if (waehrung.length < 2) {
      newErrors[`pf_${forderung.id}_waehrung`] = 'Währung muss mindestens 2 Zeichen lang sein';
    } else if (waehrung.length > 10) {
      newErrors[`pf_${forderung.id}_waehrung`] = 'Währung darf maximal 10 Zeichen lang sein';
    }

    if (!betragStr) {
      newErrors[`pf_${forderung.id}_betrag`] = 'Betrag ist erforderlich';
    } else {
      const betragNum = parseFloat(betragStr.replace(',', '.'));
      if (isNaN(betragNum)) {
        newErrors[`pf_${forderung.id}_betrag`] = 'Betrag muss eine gültige Zahl sein';
      } else if (betragStr.replace(/[.,]/g, '').replace(/^-/, '').length > 20) {
        newErrors[`pf_${forderung.id}_betrag`] = 'Betrag darf maximal 20 Stellen haben';
      }
    }

    if (!vorgangsNr) {
      newErrors[`pf_${forderung.id}_vorgangsNr`] = 'Darlehen-Nr. ist erforderlich';
    } else if (vorgangsNr.length < 2) {
      newErrors[`pf_${forderung.id}_vorgangsNr`] = 'Darlehen-Nr. muss mindestens 2 Zeichen lang sein';
    } else if (vorgangsNr.length > 100) {
      newErrors[`pf_${forderung.id}_vorgangsNr`] = 'Darlehen-Nr. darf maximal 100 Zeichen lang sein';
    }
  });

  // Globale Prüfung
  const isAnyPfAktivVal = persoenlicheForderungen.some(f => isPfAktiv(f));
  const isAnyGpAktivVal = grundpfandrechte.some(g => isGpAktiv(g));
  if (!isAnyPfAktivVal && !isAnyGpAktivVal) {
    newErrors.global = 'Mindestens eine Forderung oder Sicherheit muss erfasst werden.';
  }

  return newErrors;
};
